import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const LetsTalkButton = ({ closeMenu }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    if (typeof closeMenu === 'function') {
      closeMenu();
    }

    navigate('/contact-us');
  };

  return (
    <button className="cta-btn" onClick={handleClick}>
      Let’s Talk
      <span className="cta-arrow" aria-hidden="true">
        <svg width="20" height="15" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 24L24 8" stroke="white" strokeWidth="3" strokeLinecap="round"/>
          <path d="M12 8H24V20" stroke="white" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </span>
    </button>
  );
};

export default LetsTalkButton;